var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    stroke: "white",
    fill: "#00C271",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.517 15.1869H3.375C3.22582 15.1869 3.08274 15.1277 2.97725 15.0222C2.87176 14.9167 2.8125 14.7736 2.8125 14.6244V11.4824C2.8125 11.4086 2.82705 11.3354 2.85532 11.2672C2.88359 11.1989 2.92502 11.1369 2.97725 11.0847L11.4148 2.64717C11.5202 2.54168 11.6633 2.48242 11.8125 2.48242C11.9617 2.48242 12.1048 2.54168 12.2102 2.64717L15.3523 5.78918C15.4577 5.89467 15.517 6.03774 15.517 6.18693C15.517 6.33611 15.4577 6.47919 15.3523 6.58467L6.91475 15.0222C6.86252 15.0744 6.80051 15.1158 6.73226 15.1441C6.66402 15.1724 6.59087 15.1869 6.517 15.1869Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 4.5L13.5 8.4375",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil_icon.2a76effeade324b63c805c73aba7e51f.svg";
export { ForwardRef as ReactComponent };